import React from 'react';
import { Header } from './Header';
import { ProductGallery } from './ProductGallery';
import { ProductDetails } from './ProductDetails';
import { Cart } from './Cart';
export const ProductPage = () => {
  const productImages = [{
    id: 1,
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bg7uqfWRwQzGauPqVfKHni/1.png',
    alt: 'Front view of black PowerFlex Performance Tee'
  }, {
    id: 2,
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wEXL21iEtAoCGuBvae4uCo/2.png',
    alt: 'Side view of black PowerFlex Performance Tee'
  }, {
    id: 3,
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c3nbxB4gqU4P3dZY7y3xCo/3.png',
    alt: 'Back view of black PowerFlex Performance Tee'
  }, {
    id: 4,
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3ThWbKCqmPVsh3BZmRDyAf/4.png',
    alt: 'Active lifestyle view of black PowerFlex Performance Tee'
  }];
  const productDetails = {
    name: 'PowerFlex Performance Tee',
    description: 'Ultra-soft, moisture-wicking fabric perfect for workouts and everyday wear. Designed for active lifestyles, this versatile performance tee keeps you cool and comfortable during intense workouts while looking stylish for casual outings. The four-way stretch fabric moves with you, ensuring unrestricted mobility for any activity.',
    price: 29.99,
    sku: 'PFPT-001',
    image: productImages[0].src // Pass the main image to ProductDetails
  };
  return <div className="min-h-screen bg-white" data-id="element-230">
      <Header data-id="element-231" />
      <Cart data-id="element-232" />
      <main className="py-8" data-id="element-233">
        <div className="container mx-auto px-4" data-id="element-234">
          <nav className="mb-6" data-id="element-235">
            <ol className="flex text-sm" data-id="element-236">
              <li className="text-gray-500" data-id="element-237">
                <a href="#" className="hover:text-fuchsia-600 transition-colors" data-id="element-238">
                  Home
                </a>
              </li>
              <li className="mx-2 text-gray-500" data-id="element-239">/</li>
              <li className="text-gray-500" data-id="element-240">
                <a href="#" className="hover:text-fuchsia-600 transition-colors" data-id="element-241">
                  Women
                </a>
              </li>
              <li className="mx-2 text-gray-500" data-id="element-242">/</li>
              <li className="text-gray-900 font-medium" data-id="element-243">
                PowerFlex Performance Tee
              </li>
            </ol>
          </nav>
          <div className="lg:flex lg:items-start lg:space-x-8" data-id="element-244">
            <ProductGallery images={productImages} data-id="element-245" />
            <ProductDetails {...productDetails} data-id="element-246" />
          </div>
        </div>
      </main>
      <footer className="bg-gray-100 py-12" data-id="element-247">
        <div className="container mx-auto px-4" data-id="element-248">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-249">
            <div data-id="element-250">
              <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-251">
                AI Shirts
              </h3>
              <p className="text-gray-600" data-id="element-252">
                Performance apparel for active lifestyles.
              </p>
            </div>
            <div data-id="element-253">
              <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-254">
                Quick Links
              </h3>
              <ul className="space-y-2" data-id="element-255">
                <li data-id="element-256">
                  <a href="#" className="text-gray-600 hover:text-fuchsia-600 transition-colors" data-id="element-257">
                    About Us
                  </a>
                </li>
                <li data-id="element-258">
                  <a href="#" className="text-gray-600 hover:text-fuchsia-600 transition-colors" data-id="element-259">
                    Contact
                  </a>
                </li>
                <li data-id="element-260">
                  <a href="#" className="text-gray-600 hover:text-fuchsia-600 transition-colors" data-id="element-261">
                    FAQs
                  </a>
                </li>
                <li data-id="element-262">
                  <a href="#" className="text-gray-600 hover:text-fuchsia-600 transition-colors" data-id="element-263">
                    Shipping
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-264">
              <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-265">
                Stay Connected
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-266">
                Join our newsletter for updates and offers.
              </p>
              <div className="flex" data-id="element-267">
                <input type="email" placeholder="Your email" className="px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:border-transparent" aria-label="Email address" data-id="element-268" />
                <button className="bg-fuchsia-600 text-white px-4 py-2 rounded-r-md hover:bg-fuchsia-700 transition-colors" data-id="element-269">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-270">
            <p className="text-center text-gray-500 text-sm" data-id="element-271">
              © {new Date().getFullYear()} AI Shirts. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
};